module.exports = __webpack_public_path__ + "media/ca2a_manifesto.a2bffc21.mp4";